import { getCurrentUrl } from '@common';
import { createApiClient } from '@hypeit-gmbh/hypeit-ui-core';
import { AxiosError, AxiosInstance, AxiosRequestConfig } from 'axios';

const BASE_URL = __API_URL__;

const AXIOS_INSTANCE: AxiosInstance = createApiClient({
  baseURL: BASE_URL,
  timeout: 15000,
  nonProtectedEndpoints: ['/auth/refresh-token'],
  refreshTokenFn: async () => {
    const res = await AXIOS_INSTANCE.post(
      `${BASE_URL}/auth-service-v1/auth/refresh-token`,
      {}
    );
    return res.data.data.accessToken;
  },
  addHeaders: () => {
    const tenantToken = localStorage.getItem('tenant-token');
    return {
      'Content-Type': 'application/json',
      Platform: 'WEB',
      'Tenant-Token': tenantToken || '',
    };
  },
  onRefreshFail: () => {
    const currentUrl = getCurrentUrl();
    window.location.href = `/login?return_to=${currentUrl}`;
  },
});

export const customInstance = <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig
): Promise<T> => {
  return AXIOS_INSTANCE({
    ...config,
    ...options,
  }).then(({ data }) => data);
};

export type ErrorType<Error> = AxiosError<Error>;
export type BodyType<BodyData> = BodyData;
